;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('buttonDropdown', buttonDropdown)

  /* @ngInject */
  function buttonDropdown () {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        iconItems: '<'
      },
      templateUrl: '/core/directives/button-dropdown/button-dropdown-directive.html?$$REVISION$$',
      controller: 'ButtonDropdownController'
    }
  }
})()
